<template>
    <div class="carBox" style="flex-direction: column;">
        <el-card style="width: 100%;height: auto;">
            <div slot="header" class="clearfix">
                <span>非接触抽检监测</span>
            </div>
            <div class="uncontactList">
                <div class="uncontactLine" v-for="(item, idx) in uncontactList" :key="item.id">
                    <div :class="(item.alert1 >0 || item.alert2>0 || item.alert3>0)?'uncontactBox boxAlert':'uncontactBox'" style="width: 360px">
                        <div class="deviceState1" v-if="item.state =='1'">运行</div>
                        <div class="deviceState2" v-else-if="item.state =='2'">停机</div>
                        <div class="deviceState3" v-else>离线</div>
                        <div class="deviceBox">
                            <div class="titleBox">
                                <div class="txt1">设备编号：{{item.code}}</div>
                                <div class="txt2">所在位置：{{item.location}}</div>
                            </div>
                            <div class="exceptionLine">
                                <div class="exceptionBox">
                                    <div class="txt1" v-if="item.volumeInException1=='正常' || item.volumeInException1 =='-'">进浆：{{item.volumeInException1}}</div>
                                    <div class="txt1" v-else>进浆：<span class="hl">{{item.volumeInException1}}</span></div>
                                    <div class="txt1" v-if="item.volumeLeakException1=='正常' || item.volumeLeakException1 =='-'">回浆：{{item.volumeLeakException1}}</div>
                                    <div class="txt1" v-else>回浆：<span class="hl">{{item.volumeLeakException1}}</span></div>
                                    <div class="txt1" v-if="item.pressureException1=='正常' || item.pressureException1 =='-'">压力：{{item.pressureException1}}</div>
                                    <div class="txt1" v-else>压力：<span class="hl">{{item.pressureException1}}</span></div>
                                    <div class="txt1" v-if="item.densityException1=='正常' || item.densityException1 =='-'">密度：{{item.densityException1}}</div>
                                    <div class="txt1" v-else>密度：<span class="hl">{{item.densityException1}}</span></div>
                                </div>
                                <el-image class="deviceimg" :src="require('@/assets/uncontact.png')" v-if="item.device_type =='1'"></el-image>
                                <el-image class="deviceimg1" :src="require('@/assets/uncontact1.png')" v-else></el-image>
                            </div>
                        </div>
                        <div class="channelBox">
                            <div class="line"></div>
                            <div class="passagewayBox">
                                <template v-if="item.channel_no=='1'">
                                    <div class="name act" v-if="item.state1==1">通道{{item.channel_no}}</div>
                                    <div class="name" v-else>通道{{item.channel_no}}</div>
                                </template>
                                <template v-if="item.channel_no=='2'">
                                    <div class="name act" v-if="item.state1==1">通道{{item.channel_no}}</div>
                                    <div class="name" v-else>通道{{item.channel_no}}</div>
                                </template>
                                <div class="txtBox txtBox1" :style="item.alert1>0?'color: red':''">流量:<label class="gl" :style="item.alert1>0?'color: red':''">{{(item.state==0 && item.flow1==0)?'--':item.flow1}}</label>L</div>
                                <div class="txtBox txtBox2" :style="item.alert2>0?'color: red':''">压力:<label class="gl" :style="item.alert2>0?'color: red':''">{{(item.state==0 && item.pressure1==0)?'--':item.pressure1}}</label>MPa</div>
                                <div class="txtBox txtBox3" :style="item.alert3>0?'color: red':''">密度:<label class="gl" :style="item.alert3>0?'color: red':''">{{(item.state==0 && item.density1==0)?'--':item.density1}}</label>g/cm³</div>
                            </div>
                        </div>
                        <el-image class="cancelIcon" v-if="set=='1'" title="取消报警" @click="cancel1(item.id, item.code)" :src="require('@/assets/icon_cancel.png')"></el-image>
                        <el-image class="userIcon" v-if="set=='1'" title="取消报警" @click="setUser(item.id, 3)" :src="require('@/assets/icon_users.png')"></el-image>
                        <el-image class="setIcon" v-if="set=='1'" title="设备配置" @click="edit1(item.id)" :src="require('@/assets/icon_set.png')"></el-image>
                    </div>
                    <div :class="(item.alert4 >0)?'uncontactBox boxAlert':'uncontactBox'" :id="'line'+idx+'1'"></div>
                    <div :class="(item.alert5 >0)?'uncontactBox boxAlert':'uncontactBox'" :id="'line'+idx+'2'"></div>
                    <div :class="(item.alert6 >0)?'uncontactBox boxAlert':'uncontactBox'" :id="'line'+idx+'3'"></div>
                </div>
            </div>
        </el-card>
        
        <el-card style="width: 100%;height: auto; margin: 30px 0; padding-bottom: 0px">
            <div slot="header" class="clearfix">
                <span>数据采集监测</span>
            </div>
            <div class="contactList">
                <div :class="(item.alert1 >0 || item.alert2 >0 || item.alert3 >0 || item.alert4 >0 || item.alert5 >0 || item.alert6 >0)?'contactBox boxAlert':'contactBox'" v-for="item in contactList" :key="item.id" style="margin-bottom: 14px;">
                    <div class="deviceState1" v-if="item.state =='1'">运行</div>
                    <div class="deviceState2" v-else-if="item.state =='2'">停机</div>
                    <div class="deviceState3" v-else>离线</div>
                    <div class="deviceBox">
                        <div class="titleBox">
                            <div class="txt1">设备编号：{{item.code}}</div>
                            <div class="txt2">所在位置：{{item.location}}</div>
                        </div>
                        <div class="exceptionLine">
                            <div class="exceptionBox" v-if="item.channel_use1=='1'">
                                <div class="txt1" v-if="item.volumeInException1=='正常' || item.volumeInException1 =='-'">进浆：{{item.volumeInException1}}</div>
                                <div class="txt1" v-else>进浆：<span class="hl">{{item.volumeInException1}}</span></div>
                                <div class="txt1" v-if="item.volumeLeakException1=='正常' || item.volumeLeakException1 =='-'">回浆：{{item.volumeLeakException1}}</div>
                                <div class="txt1" v-else>回浆：<span class="hl">{{item.volumeLeakException1}}</span></div>
                                <div class="txt1" v-if="item.pressureException1=='正常' || item.pressureException1 =='-'">压力：{{item.pressureException1}}</div>
                                <div class="txt1" v-else>压力：<span class="hl">{{item.pressureException1}}</span></div>
                                <div class="txt1" v-if="item.densityException1=='正常' || item.densityException1 =='-'">密度：{{item.densityException1}}</div>
                                <div class="txt1" v-else>密度：<span class="hl">{{item.densityException1}}</span></div>
                            </div>
                            <el-image class="deviceimg" :src="require('@/assets/contact.png')"></el-image>
                            <div class="exceptionBox" v-if="item.channel_use2=='1'">
                                <div class="txt1" v-if="item.volumeInException2=='正常' || item.volumeInException2 =='-'">进浆：{{item.volumeInException2}}</div>
                                <div class="txt1" v-else>进浆：<span class="hl">{{item.volumeInException2}}</span></div>
                                <div class="txt1" v-if="item.volumeLeakException2=='正常' || item.volumeLeakException2 =='-'">回浆：{{item.volumeLeakException2}}</div>
                                <div class="txt1" v-else>回浆：<span class="hl">{{item.volumeLeakException2}}</span></div>
                                <div class="txt1" v-if="item.pressureException2=='正常' || item.pressureException2 =='-'">压力：{{item.pressureException2}}</div>
                                <div class="txt1" v-else>压力：<span class="hl">{{item.pressureException2}}</span></div>
                                <div class="txt1" v-if="item.densityException2=='正常' || item.densityException2 =='-'">密度：{{item.densityException2}}</div>
                                <div class="txt1" v-else>密度：<span class="hl">{{item.densityException2}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="channelBox">
                        <div class="line"></div>
                        <div class="passagewayBox" v-if="item.channel_use1=='1'">
                            <div class="name act" v-if="item.state1==1">通道1</div>
                            <div class="name" v-else>通道1</div>
                            <div class="txtBox txtBox1" :style="item.alert1>0?'color: red':''">流量:<label class="gl" :style="item.alert1>0?'color: red':''">{{(item.state==0 && item.flow1==0)?'--':item.flow1}}</label>L</div>
                            <div class="txtBox txtBox2" :style="item.alert2>0?'color: red':''">压力:<label class="gl" :style="item.alert2>0?'color: red':''">{{(item.state==0 && item.pressure1==0)?'--':item.pressure1}}</label>MPa</div>
                            <div class="txtBox txtBox3" :style="item.alert3>0?'color: red':''">密度:<label class="gl" :style="item.alert3>0?'color: red':''">{{(item.state==0 && item.density1==0)?'--':item.density1}}</label>g/cm³</div>
                        </div>
                        <div class="passagewayBox" v-if="item.channel_use2=='1'">
                            <div class="name act" v-if="item.state2==1">通道2</div>
                            <div class="name" v-else>通道2</div>
                            <div class="txtBox txtBox1" :style="item.alert4>0?'color: red':''">流量:<label class="gl" :style="item.alert4>0?'color: red':''">{{(item.state==0 && item.flow2==0)?'--':item.flow2}}</label>L</div>
                            <div class="txtBox txtBox2" :style="item.alert5>0?'color: red':''">压力:<label class="gl" :style="item.alert5>0?'color: red':''">{{(item.state==0 && item.pressure2==0)?'--':item.pressure2}}</label>MPa</div>
                            <div class="txtBox txtBox3" :style="item.alert6>0?'color: red':''">密度:<label class="gl" :style="item.alert6>0?'color: red':''">{{(item.state==0 && item.density2==0)?'--':item.density2}}</label>g/cm³</div>
                        </div>
                    </div>
                    <el-image class="cancelIcon" v-if="set=='1'" title="取消报警" @click="cancel2(item.id, item.code)" :src="require('@/assets/icon_cancel.png')"></el-image>
                    <el-image class="userIcon" v-if="set=='1'" title="取消报警" @click="setUser(item.id, 2)" :src="require('@/assets/icon_users.png')"></el-image>
                    <el-image class="setIcon" v-if="set=='1'" title="设备配置" @click="edit2(item.id)" :src="require('@/assets/icon_set.png')"></el-image>
                </div>
            </div>
        </el-card>
        <Edit1
            width="600px"
            :id="model_id"
            title="设备配置"
            :isshow="editshow1"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit1>
        <Edit2
            width="600px"
            :id="model_id"
            title="设备配置"
            :isshow="editshow2"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit2>
        <Cancel
            width="600px"
            title="临时取消报警"
            :device_type="device_type"
            :device_id="device_id"
            :device_code="device_code"
            :isshow="cancelshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Cancel>
        <DeviceUser
            width="800px"
            :device_id="model_id"
            :device_type="device_type"
            title="关联报警用户"
            :isshow="usershow"
            @on-close="closeDeviceUserDialog">
        </DeviceUser>
    </div>
</template>

<script>
import { deviceList,realData } from "@/api/moniter";
import Edit1 from "./edit1"
import Edit2 from "./edit2"
import Cancel from "./cancel"
import DeviceUser from "../deviceuser/list"

// 引入基本模板
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/component/grid')
require('echarts/lib/component/legend')
require('echarts/lib/component/title')
require('echarts/lib/component/tooltip')

export default {
    name: 'deviceState',
    components: {Edit1, Edit2, Cancel, DeviceUser},
    data() {
        return {
            m_name: '设备实时状态',
            menu_id: 1500,
            model_id: 0,
            contactList: [],
            contactList1: [],
            uncontactList: [],
            set: 0,
            model_id: 0,
            editshow1: false,
            editshow2: false,
            cancelshow: false,
            device_type: 0,
            device_id: 0,
            device_code: '',
            usershow: false,

            chart01: null,
            chart02: null,
            chart03: null,
            chart11: null,
            chart12: null,
            chart13: null,
            chart21: null,
            chart22: null,
            chart23: null,
            chart31: null,
            chart32: null,
            chart33: null,
            chart41: null,
            chart42: null,
            chart43: null,

            option01: {
                title: {
                    text: '流量(L)',
                    textStyle: {
                        fontSize: 14
                    },
                },
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: ['非接触设备', '数据采集器']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    top: '18%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        // 使用 formatter 函数格式化标签
                        formatter: function(value) {
                            // 对 value 进行四舍五入，保留两位小数
                            return value.toFixed(2);
                        }
                    }
                },
                series: [
                    {
                        name: '非接触设备',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '数据采集器',
                        type: 'line',
                        data: []
                    }
                ]
            },
            option02: {
                title: {
                    text: '压力(MPa)',
                    textStyle: {
                        fontSize: 14
                    },
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['非接触设备', '数据采集器']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    top: '18%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        // 使用 formatter 函数格式化标签
                        formatter: function(value) {
                            // 对 value 进行四舍五入，保留两位小数
                            return value.toFixed(2);
                        }
                    }
                },
                series: [
                    {
                        name: '非接触设备',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '数据采集器',
                        type: 'line',
                        data: []
                    }
                ]
            },
            option03: {
                title: {
                    text: '密度(g/cm³)',
                    textStyle: {
                        fontSize: 14
                    },
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['非接触设备', '数据采集器']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    top: '18%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        // 使用 formatter 函数格式化标签
                        formatter: function(value) {
                            // 对 value 进行四舍五入，保留两位小数
                            return value.toFixed(2);
                        }
                    }
                },
                series: [
                    {
                        name: '非接触设备',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '数据采集器',
                        type: 'line',
                        data: []
                    }
                ]
            },
            option11: {
                title: {
                    text: '流量(L)',
                    textStyle: {
                        fontSize: 14
                    },
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['非接触设备', '数据采集器']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    top: '18%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        // 使用 formatter 函数格式化标签
                        formatter: function(value) {
                            // 对 value 进行四舍五入，保留两位小数
                            return value.toFixed(2);
                        }
                    }
                },
                series: [
                    {
                        name: '非接触设备',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '数据采集器',
                        type: 'line',
                        data: []
                    }
                ]
            },
            option12: {
                title: {
                    text: '压力(MPa)',
                    textStyle: {
                        fontSize: 14
                    },
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['非接触设备', '数据采集器']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    top: '18%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        // 使用 formatter 函数格式化标签
                        formatter: function(value) {
                            // 对 value 进行四舍五入，保留两位小数
                            return value.toFixed(2);
                        }
                    }
                },
                series: [
                    {
                        name: '非接触设备',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '数据采集器',
                        type: 'line',
                        data: []
                    }
                ]
            },
            option13: {
                title: {
                    text: '密度(g/cm³)',
                    textStyle: {
                        fontSize: 14
                    },
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['非接触设备', '数据采集器']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    top: '18%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        // 使用 formatter 函数格式化标签
                        formatter: function(value) {
                            // 对 value 进行四舍五入，保留两位小数
                            return value.toFixed(2);
                        }
                    }
                },
                series: [
                    {
                        name: '非接触设备',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '数据采集器',
                        type: 'line',
                        data: []
                    }
                ]
            },
            option21: {
                title: {
                    text: '流量(L)',
                    textStyle: {
                        fontSize: 14
                    },
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['非接触设备', '数据采集器']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    top: '18%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        // 使用 formatter 函数格式化标签
                        formatter: function(value) {
                            // 对 value 进行四舍五入，保留两位小数
                            return value.toFixed(2);
                        }
                    }
                },
                series: [
                    {
                        name: '非接触设备',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '数据采集器',
                        type: 'line',
                        data: []
                    }
                ]
            },
            option22: {
                title: {
                    text: '压力(MPa)',
                    textStyle: {
                        fontSize: 14
                    },
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['非接触设备', '数据采集器']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    top: '18%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        // 使用 formatter 函数格式化标签
                        formatter: function(value) {
                            // 对 value 进行四舍五入，保留两位小数
                            return value.toFixed(2);
                        }
                    }
                },
                series: [
                    {
                        name: '非接触设备',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '数据采集器',
                        type: 'line',
                        data: []
                    }
                ]
            },
            option23: {
                title: {
                    text: '密度(g/cm³)',
                    textStyle: {
                        fontSize: 14
                    },
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['非接触设备', '数据采集器']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    top: '18%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        // 使用 formatter 函数格式化标签
                        formatter: function(value) {
                            // 对 value 进行四舍五入，保留两位小数
                            return value.toFixed(2);
                        }
                    }
                },
                series: [
                    {
                        name: '非接触设备',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '数据采集器',
                        type: 'line',
                        data: []
                    }
                ]
            },
            option31: {
                title: {
                    text: '流量(L)',
                    textStyle: {
                        fontSize: 14
                    },
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['非接触设备', '数据采集器']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    top: '18%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        // 使用 formatter 函数格式化标签
                        formatter: function(value) {
                            // 对 value 进行四舍五入，保留两位小数
                            return value.toFixed(2);
                        }
                    }
                },
                series: [
                    {
                        name: '非接触设备',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '数据采集器',
                        type: 'line',
                        data: []
                    }
                ]
            },
            option32: {
                title: {
                    text: '压力(MPa)',
                    textStyle: {
                        fontSize: 14
                    },
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['非接触设备', '数据采集器']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    top: '18%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        // 使用 formatter 函数格式化标签
                        formatter: function(value) {
                            // 对 value 进行四舍五入，保留两位小数
                            return value.toFixed(2);
                        }
                    }
                },
                series: [
                    {
                        name: '非接触设备',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '数据采集器',
                        type: 'line',
                        data: []
                    }
                ]
            },
            option33: {
                title: {
                    text: '密度(g/cm³)',
                    textStyle: {
                        fontSize: 14
                    },
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['非接触设备', '数据采集器']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    top: '18%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        // 使用 formatter 函数格式化标签
                        formatter: function(value) {
                            // 对 value 进行四舍五入，保留两位小数
                            return value.toFixed(2);
                        }
                    }
                },
                series: [
                    {
                        name: '非接触设备',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '数据采集器',
                        type: 'line',
                        data: []
                    }
                ]
            },
            option41: {
                title: {
                    text: '流量(L)',
                    textStyle: {
                        fontSize: 14
                    },
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['非接触设备', '数据采集器']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    top: '18%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        // 使用 formatter 函数格式化标签
                        formatter: function(value) {
                            // 对 value 进行四舍五入，保留两位小数
                            return value.toFixed(2);
                        }
                    }
                },
                series: [
                    {
                        name: '非接触设备',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '数据采集器',
                        type: 'line',
                        data: []
                    }
                ]
            },
            option42: {
                title: {
                    text: '压力(MPa)',
                    textStyle: {
                        fontSize: 14
                    },
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['非接触设备', '数据采集器']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    top: '18%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        // 使用 formatter 函数格式化标签
                        formatter: function(value) {
                            // 对 value 进行四舍五入，保留两位小数
                            return value.toFixed(2);
                        }
                    }
                },
                series: [
                    {
                        name: '非接触设备',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '数据采集器',
                        type: 'line',
                        data: []
                    }
                ]
            },
            option43: {
                title: {
                    text: '密度(g/cm³)',
                    textStyle: {
                        fontSize: 14
                    },
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['非接触设备', '数据采集器']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    top: '18%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        // 使用 formatter 函数格式化标签
                        formatter: function(value) {
                            // 对 value 进行四舍五入，保留两位小数
                            return value.toFixed(2);
                        }
                    }
                },
                series: [
                    {
                        name: '非接触设备',
                        type: 'line',
                        data: []
                    },
                    {
                        name: '数据采集器',
                        type: 'line',
                        data: []
                    }
                ]
            },
        };
    },
    mounted() {
        this.getDeviceList()
    },
    methods: {
        getDeviceList(){
            deviceList().then(res=>{
                if(res.code ==1){
                    this.contactList = res.data.contactList
                    this.contactList1 = res.data.contactList1
                    this.uncontactList = res.data.uncontactList
                    this.set = res.data.set
                    
                    setTimeout(() => {
                        this.getRealData()
                        try {
                            this['chart01'] = echarts.init(document.getElementById("line01"));
                            this['chart02'] = echarts.init(document.getElementById("line02"));
                            this['chart03'] = echarts.init(document.getElementById("line03"));
                        } catch (error) {}
                        try {
                            this['chart11'] = echarts.init(document.getElementById("line11"));
                            this['chart12'] = echarts.init(document.getElementById("line12"));
                            this['chart13'] = echarts.init(document.getElementById("line13"));
                        } catch (error) {}
                        try {
                            this['chart21'] = echarts.init(document.getElementById("line21"));
                            this['chart22'] = echarts.init(document.getElementById("line22"));
                            this['chart23'] = echarts.init(document.getElementById("line23"));
                        } catch (error) {}
                        try {
                            this['chart31'] = echarts.init(document.getElementById("line31"));
                            this['chart32'] = echarts.init(document.getElementById("line32"));
                            this['chart33'] = echarts.init(document.getElementById("line33"));
                        } catch (error) {}
                        try {
                            this['chart41'] = echarts.init(document.getElementById("line41"));
                            this['chart42'] = echarts.init(document.getElementById("line42"));
                            this['chart43'] = echarts.init(document.getElementById("line43"));
                        } catch (error) {}
                    }, 1000);
                }
            })
        },
        getRealData(){
            realData().then(res=>{
                if(res.code ==1){
                    let contactDataList = res.data.contactDataList
                    let uncontactDataList = res.data.uncontactDataList
                    if(contactDataList && this.contactList && contactDataList.length>0 && this.contactList.length>0 && this.contactList.length == contactDataList.length){
                        for(let i=0; i<contactDataList.length; i++){
                            let vo = contactDataList[i]
                            let ttt = 0;
                            for(let j=0; i<this.contactList.length; j++){
                                let t = this.contactList[j]
                                ttt = j;
                                if(vo.code == t.code){
                                    let volist = vo.data
                                    if(volist.length>0){
                                        let t = volist[volist.length-1]
                                        this.contactList[j].flow1 = t.flow1.toFixed(2)
                                        this.contactList[j].pressure1 = t.pressure1.toFixed(2)
                                        this.contactList[j].density1 = t.density1.toFixed(2)
                                        this.contactList[j].flow2 = t.flow2.toFixed(2)
                                        this.contactList[j].pressure2 = t.pressure2.toFixed(2)
                                        this.contactList[j].density2 = t.density2.toFixed(2)
                                        this.contactList[j].alert = t.alert
                                        this.contactList[j].volumeInException1 = t.volumeInException1
                                        this.contactList[j].volumeLeakException1 = t.volumeLeakException1
                                        this.contactList[j].pressureException1 = t.pressureException1
                                        this.contactList[j].densityException1 = t.densityException1
                                        this.contactList[j].volumeInException2 = t.volumeInException2
                                        this.contactList[j].volumeLeakException2 = t.volumeLeakException2
                                        this.contactList[j].pressureException2 = t.pressureException2
                                        this.contactList[j].densityException2 = t.densityException2

                                        let data0 = new Array()
                                        let data1 = new Array()
                                        let data2 = new Array()
                                        let data3 = new Array()
                                        let data4 = new Array()
                                        let data5 = new Array()
                                        let data6 = new Array()
                                        if(volist.length>0){
                                            for(let k=0; k<volist.length; k++){
                                                let d = volist[k]
                                                data0.push(d.time)
                                                data1.push(d.flow1)
                                                if(d.pressure1 <0){
                                                    data2.push(0)
                                                }else{
                                                    data2.push(d.pressure1)
                                                }                                                
                                                data3.push(d.density1)
                                                data4.push(d.flow2)
                                                if(d.pressure2 <0){
                                                    data5.push(0)
                                                }else{
                                                    data5.push(d.pressure2)
                                                }
                                                data6.push(d.density2)
                                            }
                                        }
                                        this.contactList[j]['data0'] = data0
                                        this.contactList[j]['data1'] = data1
                                        this.contactList[j]['data2'] = data2
                                        this.contactList[j]['data3'] = data3
                                        this.contactList[j]['data4'] = data4
                                        this.contactList[j]['data5'] = data5
                                        this.contactList[j]['data6'] = data6
                                    }
                                    this.contactList[j].state = vo.state
                                    break;
                                }
                            }
                            this.contactList[ttt].state = vo.state
                            this.contactList[ttt].state1 = vo.state1
                            this.contactList[ttt].state2 = vo.state2
                            this.contactList[ttt].alert1 = vo.alert1
                            this.contactList[ttt].alert2 = vo.alert2
                            this.contactList[ttt].alert3 = vo.alert3
                            this.contactList[ttt].alert4 = vo.alert4
                            this.contactList[ttt].alert5 = vo.alert5
                            this.contactList[ttt].alert6 = vo.alert6
                        }
                    }

                    if(uncontactDataList && this.uncontactList && uncontactDataList.length>0 && this.uncontactList.length>0 && this.uncontactList.length == uncontactDataList.length){
                        for(let i=0; i<uncontactDataList.length; i++){
                            let vo = uncontactDataList[i]
                            let ttt = 0
                            for(let j=0; j<this.uncontactList.length; j++){
                                let t = this.uncontactList[j]
                                ttt = j;
                                if(vo.code == t.code){
                                    let volist = vo.data
                                    if(volist.length>0){
                                        let t = volist[volist.length-1]
                                        this.uncontactList[j].flow1 = t.flow1.toFixed(2)
                                        this.uncontactList[j].pressure1 = t.pressure1.toFixed(2)
                                        this.uncontactList[j].density1 = t.density1.toFixed(2)
                                        this.uncontactList[j].volumeInException1 = t.volumeInException1
                                        this.uncontactList[j].volumeLeakException1 = t.volumeLeakException1
                                        this.uncontactList[j].pressureException1 = t.pressureException1
                                        this.uncontactList[j].densityException1 = t.densityException1

                                        let data0 = new Array()
                                        let data1 = new Array()
                                        let data2 = new Array()
                                        let data3 = new Array()
                                        if(volist.length>0){
                                            for(let k=0; k<volist.length; k++){
                                                let d = volist[k]
                                                data0.push(d.time)
                                                data1.push(d.flow1)
                                                if(d.pressure1<0){
                                                    data2.push(0)
                                                }else{
                                                    data2.push(d.pressure1)
                                                }
                                                data3.push(d.density1)
                                            }
                                        }
                                        this.uncontactList[j]['data0'] = data0
                                        this.uncontactList[j]['data1'] = data1
                                        this.uncontactList[j]['data2'] = data2
                                        this.uncontactList[j]['data3'] = data3
                                    }
                                    this.uncontactList[j].state = vo.state
                                    break;
                                }
                            }
                            this.uncontactList[ttt].state = vo.state
                            this.uncontactList[ttt].state1 = vo.state1
                            this.uncontactList[ttt].alert1 = vo.alert1
                            this.uncontactList[ttt].alert2 = vo.alert2
                            this.uncontactList[ttt].alert3 = vo.alert3
                            this.uncontactList[ttt].alert4 = vo.alert4
                            this.uncontactList[ttt].alert5 = vo.alert5
                            this.uncontactList[ttt].alert6 = vo.alert6
                        }

                        for(let i=0; i<this.uncontactList.length; i++){
                            let u = this.uncontactList[i]
                            for(let j=0; j<this.contactList.length; j++){
                                let c = this.contactList[j]
                                if(u.check_code == c.code){
                                    if(u.channel_no == '1'){
                                        this['option'+i+'1'].xAxis.data = u.data0
                                        this['option'+i+'1'].series[0].data = u.data1
                                        this['option'+i+'1'].series[1].data = c.data1

                                        this['option'+i+'2'].xAxis.data = u.data0
                                        this['option'+i+'2'].series[0].data = u.data2
                                        this['option'+i+'2'].series[1].data = c.data2

                                        this['option'+i+'3'].xAxis.data = u.data0
                                        this['option'+i+'3'].series[0].data = u.data3
                                        this['option'+i+'3'].series[1].data = c.data3
                                    }else if(u.channel_no == '2'){
                                        this['option'+i+'1'].xAxis.data = u.data0
                                        this['option'+i+'1'].series[0].data = u.data1
                                        this['option'+i+'1'].series[1].data = c.data4

                                        this['option'+i+'2'].xAxis.data = u.data0
                                        this['option'+i+'2'].series[0].data = u.data2
                                        this['option'+i+'2'].series[1].data = c.data5

                                        this['option'+i+'3'].xAxis.data = u.data0
                                        this['option'+i+'3'].series[0].data = u.data3
                                        this['option'+i+'3'].series[1].data = c.data6
                                    }
                                    this['option'+i+'1'].series[0].name = u.code
                                    this['option'+i+'1'].series[1].name = c.code
                                    this['option'+i+'2'].series[0].name = u.code
                                    this['option'+i+'2'].series[1].name = c.code
                                    this['option'+i+'3'].series[0].name = u.code
                                    this['option'+i+'3'].series[1].name = c.code
                                    this['option'+i+'1'].legend.data = [u.code, c.code]
                                    this['option'+i+'2'].legend.data = [u.code, c.code]
                                    this['option'+i+'3'].legend.data = [u.code, c.code]
                                    
                                    this['chart'+i+'1'].setOption(this['option'+i+'1']);
                                    this['chart'+i+'2'].setOption(this['option'+i+'2']);
                                    this['chart'+i+'3'].setOption(this['option'+i+'3']);
                                }
                            }
                        }
                    }
                    this.$globalData.timmer1 && clearTimeout(this.$globalData.timmer1)
                    this.$globalData.timmer1 = setTimeout(() => {
                        this.getRealData()
                    }, 1000);
                }else{
                    //this.$msg(res.data)
                }
            })
        },
        edit1(id){
            this.editshow1 = true
            this.model_id = id
        },
        edit2(id){
            this.editshow2 = true
            this.model_id = id
        },
        closeEditDialog(){
            this.editshow1 = false
            this.editshow2 = false
            this.cancelshow = false
        },
        saveOk(){
            this.closeEditDialog()
            this.$globalData.timmer1 && clearTimeout(this.$globalData.timmer1)
            this.getDeviceList()
        },
        cancel1(id, code){
            this.device_type = 3
            this.device_id = id
            this.device_code = code
            this.cancelshow = true
        },
        cancel2(id, code){
            this.device_type = 2
            this.device_id = id
            this.device_code = code
            this.cancelshow = true
        },
        setUser(id, device_type){
            this.model_id = id
            this.device_type = device_type
            this.usershow = true
        },
        closeDeviceUserDialog(){
            this.usershow = false
        }
    }
};
</script>
<style lang="less" scoped>
    .dTitle {
        width: 100%;
        font-size: 20px;
    }
    .contactList {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
    .contactBox {
        width: calc(calc(100% - 60px) / 4);
        height: 270px;
        border: 1px solid #e6e6e6;
        margin-right: 20px;
        border-radius: 8px;
        box-shadow: 0 1px 4px rgba(204, 204, 204, 0.2);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding: 14px 20px;
        box-sizing: border-box;
        position: relative;
    }
    .contactList > :nth-child(4n) {
        margin-right: 0;
    }
    .contactBox .deviceBox {
        width: 100%;
        height: 159px;
        position: relative;
    }
    .deviceBox .titleBox {
        width: 100%;
        height: 30px;
        line-height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
    }
    .deviceBox .titleBox .txt1{
        text-align: left;
    }
    .deviceBox .titleBox .txt2{
        text-align: right;
    }
    .deviceBox .exceptionLine{
        width: 100%;
        height: 129px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
    .exceptionBox {
        width: 85px;
        height: 110px;
        border: 1px dashed #00796A;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .contactBox .deviceimg{
        width: 100px;
        height: 77px;
    }
    .exceptionBox .txt1{
        font-size: 12px;
        margin: 4px 0;
    }
    .exceptionBox .hl{
        color: red;
    }
    .contactBox .channelBox {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 12px;
    }
    .channelBox .line {
        width: 100%;
        height: 1px;
        background-color: #F1F1F1;
        margin-bottom: 12px;
    }
    .channelBox .passagewayBox {
        width: 100%;
        height: 20px;
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-content: space-between;
        margin-bottom: 10px;
    }
    .channelBox .passagewayBox .name {
        width: 58px;
        height: 20px;
        background-color: #EBEEF5;
        border-radius: 2px;
        font-size: 12px;
        color: #606266;
        text-align: center;
        line-height: 20px;
        margin-right: 10px;
    }
    .channelBox .passagewayBox .act {
        background-color: rgba(0, 121, 106, 0.1);
        color: #00796A;
    }
    .channelBox .passagewayBox .txtBox {
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: #333333;
        letter-spacing: 0;
    }
    .channelBox .passagewayBox .txtBox1{
        width: 80px;
    }
    .channelBox .passagewayBox .txtBox2{
        width: 85px;
    }
    .channelBox .passagewayBox .txtBox3{
        width: 85px;
    }
    .channelBox .passagewayBox .txtBox .gl{
        color: #00796A;
    }
    .uncontactList {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }
    .uncontactLine {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 14px;
    }
    .uncontactBox {
        width: calc(calc(100% - 420px) / 3);
        height: 240px;
        border: 1px solid #e6e6e6;
        margin-right: 20px;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding: 14px 20px;
        box-sizing: border-box;
        position: relative;
        box-shadow: 0 1px 4px rgba(204, 204, 204, 0.2);
    }
    .boxAlert{
        box-shadow: inset 0 0 14px rgba(245,108,108, 0.5);
    }
    .uncontactLine > :nth-child(4n) {
        margin-right: 0;
    }
    .uncontactBox .deviceBox {
        width: 100%;
        height: 159px;
        position: relative;
    }
    .uncontactBox .deviceBox .titleBox {
        width: 100%;
        height: 30px;
        line-height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
    }
    .uncontactBox .deviceBox .titleBox .txt1{
        text-align: left;
    }
    .uncontactBox .deviceBox .titleBox .txt2{
        text-align: right;
    }
    .uncontactBox .deviceBox .exceptionLine {
        width: 100%;
        height: 129px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
    .uncontactBox .deviceBox .deviceimg{
        width: 76px;
        height: 110px;
    }
    .uncontactBox .deviceBox .deviceimg1{
        width: 91px;
        height: 110px;
    }
    .uncontactBox .deviceBox .exceptionLine .exceptionBox {
        width: 85px;
        height: 110px;
        border: 1px dashed #00796A;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .uncontactBox .deviceBox .exceptionLine .exceptionBox .txt1{
        font-size: 12px;
        margin: 4px 0;
    }
    .uncontactBox .deviceBox .exceptionLine .exceptionBox .span{
        font-size: red;
    }
    .uncontactBox .channelBox {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 12px;
    }
    .uncontactBox .channelBox .line {
        width: 100%;
        height: 1px;
        background-color: #F1F1F1;
        margin-bottom: 12px;
    }
    .uncontactBox .channelBox .passagewayBox {
        width: 100%;
        height: 20px;
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-content: space-between;
        margin-bottom: 10px;
    }
    .uncontactBox .passagewayBox .name {
        width: 58px;
        height: 20px;
        background-color: #EBEEF5;
        border-radius: 2px;
        font-size: 12px;
        color: #606266;
        text-align: center;
        line-height: 20px;
        margin-right: 10px;
    }
    .uncontactBox .passagewayBox .act {
        background-color: rgba(0, 121, 106, 0.1);
        color: #00796A;
    }
    .uncontactBox .passagewayBox .txtBox {
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: #333333;
        letter-spacing: 0;
    }
    .uncontactBox .passagewayBox .txtBox1{
        width: 80px;
    }
    .uncontactBox .passagewayBox .txtBox2{
        width: 85px;
    }
    .uncontactBox .passagewayBox .txtBox3{
        width: 85px;
    }
    .uncontactBox .passagewayBox .txtBox .gl{
        color: #00796A;
    }
    .deviceState1 {
        width: 62px;
        height: 20px;
        line-height: 20px;
        font-size: 13px;
        text-align: center;
        position: absolute;
        bottom: 0px;
        right: 0px;
        border-bottom-right-radius: 8px;
        border-top-left-radius: 8px;
        background: #67C23A;
        color: #FFF;
    }
    .deviceState2 {
        width: 62px;
        height: 20px;
        line-height: 20px;
        font-size: 13px;
        text-align: center;
        position: absolute;
        bottom: 0px;
        right: 0px;
        border-bottom-right-radius: 8px;
        border-top-left-radius: 8px;
        background: #F56C6C;
        color: #FFF;
    }
    .deviceState3 {
        width: 62px;
        height: 20px;
        line-height: 20px;
        font-size: 13px;
        text-align: center;
        position: absolute;
        bottom: 0px;
        right: 0px;
        border-bottom-right-radius: 8px;
        border-top-left-radius: 8px;
        background: #C0C4CC;
        color: #FFF;
    }
    .setIcon {
        width: 16px;
        height: 16px;
        position: absolute;
        right: 75px;
        bottom: 2px;
        cursor: pointer;
        z-index: 1;
    }
    .userIcon {
        width: 15px;
        height: 15px;
        position: absolute;
        right: 100px;
        bottom: 3px;
        cursor: pointer;
        z-index: 1;
    }
    .cancelIcon {
        width: 13px;
        height: 13px;
        position: absolute;
        right: 126px;
        bottom: 3px;
        cursor: pointer;
        z-index: 1;
    }
</style>